/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import { connect } from 'react-redux';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { State } from '../../../../../redux/root-reducer';
import { ExpansionPanel } from '../../../../../forms/form-components/expansion-panel/expansion-panel';
import { Grid, Paper, Typography, withStyles } from '@material-ui/core';

interface BaseProps {
    formDetails?: FormDetails;
}

interface Props extends BaseProps, StyledComponent {}

const otherBenefitsView: React.FC<Props> = ({ classes, formDetails }: Props) => {
    const otherBenefts = formDetails?.claimInformation;

    return (
        <>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Other benefits
                    </Typography>
                </Grid>
            </Grid>

            <Paper className={classes.paper}>
                <Grid container spacing={2} className={classes.marginTop2}>
                    <Grid item xs={4} lg={3}>
                        <LabeledValue
                            label="Have you claimed or do you intend claiming for payment of disability, dread disease, impairment or any similar benefit with any other insurance company?"
                            value={otherBenefts?.otherBenefits?.hasOtherBenefits}
                        />
                    </Grid>
                    {otherBenefts?.otherBenefits?.benefitDetails?.map(
                        (otherbenefit: any, index: number) => (
                            <Grid key={index}>
                                <ExpansionPanel name={`Benefit details ${index + 1}`}>
                                    <Grid container justify="flex-start">
                                        <Grid item xs={4} lg={3}>
                                            <LabeledValue
                                                label="Name of Company"
                                                value={otherbenefit.nameOfCompany}
                                            />
                                        </Grid>
                                        <Grid item xs={4} lg={3}>
                                            <LabeledValue
                                                label=" Policy Number"
                                                value={otherbenefit.policyNumber}
                                            />
                                        </Grid>
                                        <Grid item xs={4} lg={3}>
                                            <LabeledValue
                                                label="Date of Inception"
                                                value={otherbenefit.dateOfInception}
                                            />
                                        </Grid>
                                        <Grid item xs={4} lg={3}>
                                            <LabeledValue
                                                label="Value of Lump Sum/Amount of Monthly Payment"
                                                value={
                                                    otherbenefit.valueOfLumpSumOrAmountOfMonthlyPayment
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </ExpansionPanel>
                            </Grid>
                        )
                    )}
                </Grid>
            </Paper>
        </>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails ?? getFormDetails(state),
});

const mapDispatchToProps = {};

export const OtherBenefitsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(otherBenefitsView));
